<!-- the reason there's two file uploads one for logs and one for issues is because the logs and issues is on
     same page in two tabs and it made issues by adding the files to the other place where it was added to -->

<template>
  <div class="file-upload-section">
    <!-- <el-upload
      class="upload-demo"
      action="#"
      :before-upload="SubmitFile"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      multiple
      :limit="3"
      :on-exceed="handleExceed"
      :file-list="fileList"
    >
      <el-tooltip class="item" effect="dark" content="Attach file" placement="top">
        <i v-if="this.filesbeinguploaded == 0" class="el-icon-paperclip" style="font-size: 21px;  color:rgb(89, 89, 89);"></i>
        <i v-if="this.filesbeinguploaded != 0" class="el-icon-loading" style="font-size: 21px; color:rgb(89, 89, 89);"></i>
      </el-tooltip>
    </el-upload> -->

<div class="image-upload">
  <label for="file-input-issues">
      <el-tooltip class="item" effect="dark" content="Attach file" placement="top">
       <i v-if="this.filesbeinguploaded == 0" class="el-icon-paperclip" style="font-size: 21px;  color:rgb(89, 89, 89); cursor: pointer;"></i>
        <i v-if="this.filesbeinguploaded != 0" class="el-icon-loading" style="font-size: 21px; color:rgb(89, 89, 89);"></i>
      </el-tooltip> 
       </label>

  <input @input="SubmitFileIssues()" style="display: none;" id="file-input-issues" ref="file-input-issues" type="file" />
  <!-- <div> <p  v-for="file in this.fileList" :key="file"> {{file}} </p> </div> -->
</div>

    <div v-for="file in this.filesUploaded" :key="file">
      <p class="displayed-files">
        <i class="el-icon-document" @click="removeFileFromFormSubmit(file)"></i>
        {{file}}
      </p>
      <i
        style="vertical-align: top;position: relative;
                left: -11px;
                bottom: 8px;
                color:rgb(89, 89, 89);"
        class="el-icon-error"
        @click="removeFileFromFormSubmit(file)"
      ></i>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  props: {
    propertyid: String
  }, 
  data() {
    return {
      fileList: [],
      filesUploaded:[],
      filetofileidlist: {}, 
      filesbeinguploaded: 0
    };
  },
  methods: {
    SubmitFileIssues() {

      var filesInInput = this.$refs["file-input-issues"].files;
      console.log(filesInInput)
      var file = filesInInput["0"]
      this.fileList.push(file.name)

      this.filesbeinguploaded = 1;
      this.$emit("fileuploadstatus", this.filesbeinguploaded);
      const MaxContentLength = 1024 * 1024 * 10;
      //   if (file.size > MaxContentLength) {
      //     return console.log("image size exceeds 10 megabytes");
      //   }
      //   if (file.type != "image/jpeg" && file.type != "image/png") {
      //     return console.log("This is not a supported file type");
      //   }
      let filedetailsobject = {
        fileinformation: [
          {
            contenttype: file.type,
            filename: file.name,
            propertyid: null
          }
        ]
      };

    if(this.propertyid != null && this.propertyid != ""){
      filedetailsobject.fileinformation[0].propertyid = this.propertyid;
    }
      let presignedurlholder = " presign default";
      let fileidholder = "";
      let cacheTime = null;
      EventService.GenerateFileObjectSpaceOnAws(filedetailsobject)
        .then(response => {
          fileidholder = response.data.fileinformationtoreturn[0];

          this.filetofileidlist.file =
            response.data.fileinformationtoreturn[0].fileid;
          presignedurlholder =
            response.data.fileinformationtoreturn[0].presignedurl;
           cacheTime = response.data.fileinformationtoreturn[0].cachetime;
        })
        .then(() => {
          this.filesUploaded.push(file.name + " " + file.type);
          console.log("this is file.name" + file);
          EventService.uploadFileToAws(
            presignedurlholder,
            file,
            file.type,
            file.name,
            cacheTime
          ).then(() => {
           this.filesbeinguploaded = 0;
            this.$emit("logtype");
            var fileInfo = [fileidholder, filedetailsobject, URL.createObjectURL(file)];
            this.$emit("file-id", fileInfo);
            this.$emit("fileuploadstatus", this.filesbeinguploaded);
          });
        });
    },
    removeFileFromFormSubmit(file) {
      this.$delete(this.filesUploaded, this.filesUploaded.indexOf(file));
       this.fileList.pop();
      this.$emit("removeFileId", this.filetofileidlist.file);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel the transfer of ${file.name} ?`);
    }
  }
};
</script>

<style scoped>
.loadersize {
  height: 10px;
  max-height: 10px;
}

.file-upload-section {
  display: inline-block;
  vertical-align: top;
  margin: 0px 10px;
}

.el-icon-document-add{
 font-size: 22px;
}


.displayed-files {
  font-size: 17px;
  margin-left: 9px;
}
</style>
